var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import LoadingAnimation from '@/shared/components/LoadingAnimation';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import RichTextEditor from '@/shared/components/RichTextEditor';
import { formatListValue } from '@/shared/components/FormattedListValue';
import Button from '@/shared/components/Button';
import PlaceholderModal from '@/shared/components/email/PlaceholderModal';
import emailMessages from '@/shared/components/email/emailMessages';
var EMAIL_SIGNATURE_TEMPLATE_CONTEXT = 13;
var messages = defineMessages({
    EditEmailSignatures: {
        id: 'EditEmailSignatures',
        defaultMessage: 'EditEmailSignatures',
    },
    Save: {
        id: 'Save',
        defaultMessage: 'Save',
    },
});
var EmailSignatureModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, companyId = _a.companyId;
    var intl = useIntl();
    var _b = useState([]), signatures = _b[0], setSignatures = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    var _e = useState(false), showPlaceholders = _e[0], setShowPlaceholders = _e[1];
    useEffect(function () {
        if (!show)
            return;
        setLoading(true);
        api.base
            .get("/api/Template/EmailSignature/".concat(companyId))
            .then(function (_a) {
            var data = _a.data;
            if (data != null) {
                var mapped = data.map(function (x, idx) { return (__assign(__assign({}, x), { initialContent: x.content || '', collapsed: idx !== 0 && !x.content })); });
                setSignatures(mapped);
            }
        })
            .catch(handleHttpError(intl))
            .finally(function () { return setLoading(false); });
    }, [show, companyId, intl]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (saving)
                        return [2 /*return*/];
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.base.put('/api/Template/EmailSignature', signatures)];
                case 2:
                    _a.sent();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var toggleCollapsed = function (index) {
        setSignatures(function (prev) {
            return prev.map(function (sig, i) { return (i === index ? __assign(__assign({}, sig), { collapsed: !sig.collapsed }) : sig); });
        });
    };
    var updateContent = function (index, content) {
        setSignatures(function (prev) { return prev.map(function (sig, i) { return (i === index ? __assign(__assign({}, sig), { content: content }) : sig); }); });
    };
    return (_jsxs(OkCancelModal, __assign({ title: intl.formatMessage(messages.EditEmailSignatures), show: show, onClose: onClose, onSave: handleSave, disabled: saving, size: "lg", okLabel: intl.formatMessage(messages.Save), zendeskArticle: "9576323609244", leftButton: _jsxs(Button, __assign({ onClick: function () { return setShowPlaceholders(true); } }, { children: ['{', intl.formatMessage(emailMessages.Placeholders), '}'] })) }, { children: [showPlaceholders && (_jsx(PlaceholderModal, { onSave: function () { return setShowPlaceholders(false); }, onClose: function () { return setShowPlaceholders(false); }, templateContext: EMAIL_SIGNATURE_TEMPLATE_CONTEXT })), loading ? (_jsx(LoadingAnimation, {})) : (_jsx("div", { children: signatures.map(function (signature, index) { return (_jsxs("div", __assign({ className: "control-panel subsection" }, { children: [_jsxs("div", __assign({ className: "title-block", onClick: function () { return toggleCollapsed(index); } }, { children: [_jsx("i", { className: "fa fa-inverse ".concat(signature.collapsed ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up') }), "\u00A0", _jsx("span", { children: formatListValue({ list: 'language', id: signature.language, intl: intl }) })] })), !signature.collapsed && (_jsx("div", __assign({ className: "panel-body" }, { children: _jsx(RichTextEditor, { id: "emailSignature-".concat(signature.language), initialValue: signature.initialContent || '', onChange: function (html) { return updateContent(index, html); } }, "emailSignature-".concat(signature.language)) })))] }), signature.language)); }) }))] })));
};
export default EmailSignatureModal;
